import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Form from './ManagerCreateForm';
import CreateMethod from './CreateMethod';

export default function ManagerCreateButton({
  buttonName,
  className,
  onCreate,
  enterpriseId,
  teamId,
  roles,
}) {
  const [show, setShow] = useState(false);
  const [showCreateMethod, setShowCreateMethod] = useState(false);
  const [createMethod, setCreateMethod] = useState('new');

  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);

  const onChooseCreateMethod = (method) => {
    setShowCreateMethod(false);
    setCreateMethod(method);
    openForm();
  };

  const modalHeader = 'Create a New Manager';

  return (
    <>
      <a className={className} onClick={() => setShowCreateMethod(true)}>
        {buttonName}
      </a>
      <CreateMethod
        show={showCreateMethod}
        onHide={() => setShowCreateMethod(false)}
        onChoose={onChooseCreateMethod}
      />
      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            closeForm={closeForm}
            onCreate={onCreate}
            enterpriseId={enterpriseId}
            teamId={teamId}
            roles={roles}
            createMethod={createMethod}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
